<template>
    <div class="uk-text-right uk-margin-medium-bottom" uk-toggle="mode: media; media: @m">
        <span class="tm-view-button">
            Вид: <a uk-toggle="target: #card_view; cls: uk-child-width-1-4@m tm-grid;"><span v-if="view == 'grid'" @click="changeView()" uk-icon="icon: list"></span><span v-else @click="changeView()" uk-icon="icon: grid;ratio: 1.5;"></span></a>
        </span>
    </div>
</template>
<script>
    export default {
        name: "GroupView",
        props: {
            ShopPage: {
                type: Object,
            },
            ShopPageDescendants: {
                type: [Array, Object],
                default() {
                    return []
                }
            }
        },
        data() {
            return {
                view: 'list'
            }
        },
        mounted() {
            if (localStorage.view) {
              this.view = localStorage.view;
            }
            if(this.view == 'grid'){
                $('#card_view').addClass('uk-child-width-1-4@m tm-grid');
                /*$.each($('.tm-item-shop-body div'), function (key, obj) {
                  $('.tm-item-shop-body div#'+$(obj).attr('id')).attr('uk-toggle','target: #list-'+$(obj).attr('id'));
                });*/
                this.ShopPageDescendants.forEach(function (ShopPageDescendant) {
                    $('.tm-item-shop-body div#id_'+ShopPageDescendant.id).attr('uk-toggle','target: #list-id_'+ShopPageDescendant.id);
                });
                $('.tm-item-shop-body ul').attr('aria-hidden','true');
                $('.tm-item-shop-body ul').attr('hidden','');
            }
        },
        methods: {
           changeView() {
               if(this.view == 'list'){
                   this.view = 'grid';
                   $('.tm-item-shop-body ul').attr('aria-hidden','true');
                   $('.tm-item-shop-body ul').attr('hidden','');
                   /*$.each($('.tm-item-shop-body div'), function (key, obj) {
                      $('.tm-item-shop-body div#'+$(obj).attr('id')).attr('uk-toggle','target: #list-'+$(obj).attr('id'));
                    });*/
                   this.ShopPageDescendants.forEach(function (ShopPageDescendant) {
                       $('.tm-item-shop-body div#id_'+ShopPageDescendant.id).attr('uk-toggle','target: #list-id_'+ShopPageDescendant.id);
                   });
               }else{
                   this.view = 'list';
                   $('.tm-item-shop-body ul').attr('aria-hidden','false');
                   $('.tm-item-shop-body ul').removeAttr('hidden');
                   $('.tm-item-shop-body div').removeAttr('uk-toggle');
               }
               localStorage.view = this.view;
           }
       }
    }
</script>



// WEBPACK FOOTER //
// GroupView.vue?5c235fc8